<template lang="pug">
  v-card(class="primary")
    v-card-title
      span   {{ setting.title }}
    v-card-text(class="mt-0 pt-0" v-for="(parameter, key) in setting.parameters" :key="key")
      p {{parameter.label}}
      setting-input( :label="parameter.label"
        :type="setting.type"
        :ind="parameter.ind"
        :min="parameter.min"
        :max="parameter.max"
        :step="parameter.step"
        )
</template>
<script>
import SettingInput from "@/components/Inputs/settingInput";
export default {
  name: "setting-card",
  props: {
    setting: { type: Object, default: null }
  },
  components: {
    SettingInput
  }
};
</script>
<style></style>
